import React from 'react';
import { IChartCardRightProps } from '.';
import { FiverChart } from '..';

const FiverRight: React.FC<IChartCardRightProps> = ({ helper }) => (
  <>
    <div className="flex justify-between mb3">
      <p className="f7 fw5 mt0 mb1">most frequent entry: {helper.mostFrequentValue()}</p>
      <p className="f7 fw5 mt0 mb1">{helper.measurementCount} entries</p>
    </div>
    <FiverChart range={helper.range} averagePoints={helper.averageSeries()} />
  </>
);

export default FiverRight;
